import { ofType, ActionsObservable } from "redux-observable";
import { switchMap, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { authTypes } from "../actions";
import { API_URL } from "../config/settings";
import { Headers } from "../utilites/Headers";
import { User } from "../utilites/User";
import { history } from "../config/stores";
import { toast } from "react-toastify";

export const loginEpic = (action$) =>
  action$.pipe(
    ofType(authTypes.LOG_IN),
    switchMap(({ payload }) => {
      return ajax({
        url: `${API_URL}/admin/login`,
        method: "POST",
        headers: Headers.get(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            User.authenticate(response.token, {
              token: response.token,
              ...response?.user,
            });
            history.push("/");
            obs.next({
              type: authTypes.LOG_IN_SUCCESS,
              payload: response,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            toast.error(err?.response?.error);
            obs.complete();
          });
        })
      );
    })
  );
export const logOutEpic = (action$) =>
  action$.pipe(
    ofType(authTypes.LOG_OUT),
    switchMap(() =>
      ActionsObservable.create((obs) => {
        User.signout();
        toast.success("Logged out successfully");
        obs.next({
          type: authTypes.LOG_OUT_SUCCESS,
        });
      })
    )
  );
export const requestLoginCodeEpic = (action$) =>
  action$.pipe(
    ofType(authTypes.REQUEST_LOGIN_CODE),
    switchMap(({ payload }) => {
      return ajax({
        url: `${API_URL}/admin/auth/request-login-code`,
        method: "POST",
        headers: Headers.get(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            toast.success("Verification code sent to your email");
            obs.next({
              type: authTypes.REQUEST_LOGIN_CODE_SUCCESS,
              payload: response,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            toast.error(err?.response?.error || "Failed to send verification code");
            obs.next({
              type: authTypes.AUTH_ERROR,
              payload: err?.response?.error || "Failed to send verification code",
            });
            obs.complete();
          });
        })
      );
    })
  );

export const verifyLoginCodeEpic = (action$) =>
  action$.pipe(
    ofType(authTypes.VERIFY_LOGIN_CODE),
    switchMap(({ payload }) => {
      
      
      return ajax({
        url: `${API_URL}/admin/auth/verify-login-code`,
        method: "POST",
        headers: Headers.get(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          
          
          return ActionsObservable.create((obs) => {
            // Check if response has the expected structure
            if (response.success) {
              // Original structure
              User.authenticate(response.payload.token, {
                ...response.payload.admin,
                role: "admin",
              });
              toast.success("Login successful");
              history.push("/");
              obs.next({
                type: authTypes.VERIFY_LOGIN_CODE_SUCCESS,
                payload: {
                  token: response.payload.token,
                  user: response.payload.admin,
                },
              });
            } else if (response.token && response.user) {
              // Direct structure (what you're actually getting)
              User.authenticate(response.token, {
                ...response.user,
                role: "admin",
              });
              toast.success("Login successful");
              
              history.push("/");
              obs.next({
                type: authTypes.VERIFY_LOGIN_CODE_SUCCESS,
                payload: {
                  token: response.token,
                  user: response.user,
                },
              });
            } else {
              
              obs.next({
                type: authTypes.AUTH_ERROR,
                payload: "Invalid verification code",
              });
            }
            obs.complete();
          });
        }),
        catchError((err) => {
          console.error("❌ Verify code error:", err);
          return ActionsObservable.create((obs) => {
            toast.error(err?.response?.error || "Invalid verification code");
            obs.next({
              type: authTypes.AUTH_ERROR,
              payload: err?.response?.error || "Invalid verification code",
            });
            obs.complete();
          });
        })
      );
    })
  );
